module.exports = __webpack_public_path__ + "img/twism.96bcec4e.svg";